"use client";
import { motion } from "motion/react";

export interface ResumeRow {
  id: number;
  label: string;
  fileName: string;
  description: string | null;
}

const ResumeCard = ({ resume }: { resume: ResumeRow }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="bg-(--background2) rounded-2xl p-6 border border-(--uforeground2) flex flex-col gap-3"
    >
      <h3 className="text-xl font-semibold">{resume.label}</h3>

      {resume.description && (
        <p className="text-sm text-(--foreground2)">{resume.description}</p>
      )}

      <motion.a
        href={`/api/resume/${resume.id}`}
        download={resume.fileName}
        className="mt-auto text-sm px-4 py-2 rounded-xl cursor-pointer text-center block"
        style={{ backgroundColor: "var(--uforeground2)", color: "#ffffff", textDecoration: "none" }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.97 }}
      >
        Download
      </motion.a>
    </motion.div>
  );
};

export default ResumeCard;
